import {
  DimensionExplorer,
  SelectedAttributesProvider,
} from "features/analytics";

function DimensionExplorerPage() {
  return (
    <>
      <SelectedAttributesProvider initialAttributes={[]}>
        <DimensionExplorer />
      </SelectedAttributesProvider>
    </>
  );
}

export default DimensionExplorerPage;